// extracted by mini-css-extract-plugin
module.exports = {"dir":"ArticleDir_dir__UmUkl","dir_piece_container":"ArticleDir_dir_piece_container__zViYk","dir_piece":"ArticleDir_dir_piece__ru0A2","back_button":"ArticleDir_back_button__lU0bN"};